import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Navigation from './components/Navigation';
import PlayerDetail from './components/PlayerDetail';
export function App() {
  return <BrowserRouter data-id="element-0">
      <div className="bg-gray-50 min-h-screen w-full" data-id="element-1">
        <Navigation data-id="element-2" />
        <div className="pt-6" data-id="element-3">
          <Routes data-id="element-4">
            <Route path="/players/:playerId" element={<PlayerDetail data-id="element-6" />} data-id="element-5" />
            <Route path="/" element={<Navigate to="/players/1" replace data-id="element-8" />} data-id="element-7" />
          </Routes>
        </div>
      </div>
    </BrowserRouter>;
}